/* RONCADOR - menu dos 3 tracinhos (estilo Fashion Nova)
   - o toque no icone de menu do cabecalho abre este menu no lugar do antigo;
   - abas, submenus (com voltar), favoritos e carrinho;
   - nao mexe no carrinho nem no rastreamento: so abre a gaveta que ja existe. */
(function () {
  if (window.__rcMenuFn) return;
  window.__rcMenuFn = true;

  var CHAVE = 'rcMenuAba';
  /* mesma curva e tempo da barra das abas do cabecalho */
  var CURVA = '.25s cubic-bezier(.4, 0, .2, 1)';

  function moverBarra(m, animar) {
    var nav = m.querySelector('.rcm__abas');
    var barra = m.querySelector('.rcm__barra');
    var aba = m.querySelector('[data-rcm-aba].is-on');
    if (!nav || !barra) return;
    if (!aba) {
      barra.style.opacity = '0';
      return;
    }
    var esq = aba.getBoundingClientRect().left - nav.getBoundingClientRect().left - nav.clientLeft + nav.scrollLeft;
    var dir = nav.clientWidth - esq - aba.offsetWidth;
    var antes = parseFloat(barra.style.left);
    if (!animar || isNaN(antes) || barra.style.opacity === '0') {
      barra.style.transition = 'none';
    } else if (esq > antes) {
      barra.style.transition = 'left ' + CURVA + ' .06s, right ' + CURVA;
    } else {
      barra.style.transition = 'left ' + CURVA + ', right ' + CURVA + ' .06s';
    }
    barra.style.left = esq + 'px';
    barra.style.right = dir + 'px';
    barra.style.opacity = '1';
    var fim = esq + aba.offsetWidth;
    if (esq < nav.scrollLeft || fim > nav.scrollLeft + nav.clientWidth) {
      nav.scrollTo({ left: Math.max(0, esq - 16), behavior: animar ? 'smooth' : 'auto' });
    }
  }

  function menu() {
    return document.querySelector('[data-rcm]');
  }

  function contarFavoritos(m) {
    var el = m.querySelector('[data-rcm-fav-qt]');
    if (!el) return;
    var n = 0;
    try {
      if (window.rcFav && window.rcFav.lista) n = window.rcFav.lista().length;
    } catch (e) {}
    el.textContent = n;
    el.hidden = !n;
  }

  function contarCarrinho(m) {
    var el = m.querySelector('[data-rcm-cart-qt]');
    if (!el) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        el.textContent = c.item_count;
        el.hidden = !c.item_count;
      })
      .catch(function () {});
  }

  function mostrarAba(m, id, animar) {
    var achou = false;
    m.querySelectorAll('[data-rcm-aba]').forEach(function (b) {
      var on = b.getAttribute('data-rcm-aba') === id;
      if (on) achou = true;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (!achou) return;
    m.querySelectorAll('[data-rcm-painel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-rcm-painel') !== id;
    });
    fecharSub(m);
    moverBarra(m, animar);
    try { sessionStorage.setItem(CHAVE, id); } catch (e) {}
  }

  function abrirSub(m, id) {
    var sub = m.querySelector('[data-rcm-sub="' + id + '"]');
    if (!sub) return;
    m.querySelectorAll('[data-rcm-painel]').forEach(function (p) { p.hidden = true; });
    m.querySelectorAll('[data-rcm-sub]').forEach(function (s) { s.hidden = s !== sub; });
    m.classList.add('rcm__sub-aberto');
    var corpo = m.querySelector('[data-rcm-corpo]');
    if (corpo) corpo.scrollTop = 0;
  }

  function fecharSub(m) {
    var ativa = m.querySelector('[data-rcm-aba].is-on');
    m.querySelectorAll('[data-rcm-sub]').forEach(function (s) { s.hidden = true; });
    m.classList.remove('rcm__sub-aberto');
    if (ativa) {
      var id = ativa.getAttribute('data-rcm-aba');
      m.querySelectorAll('[data-rcm-painel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-rcm-painel') !== id;
      });
    }
  }

  function cabecalho() {
    return document.querySelector('.header-wrapper > .header') || document.querySelector('header.header') || document.querySelector('sticky-header');
  }

  function posicionar(m) {
    /* com o menu aberto o cabecalho fica sempre visivel (rc-menu-fn.css);
       o menu comeca logo abaixo da linha da logo */
    var h = cabecalho();
    var topo = h ? h.getBoundingClientRect().bottom : 0;
    m.style.setProperty('--rcm-topo', Math.max(0, Math.round(topo)) + 'px');
  }

  function marcarX(on) {
    document.querySelectorAll('header-drawer details').forEach(function (d) {
      d.classList.toggle('rcm-x', on);
    });
    document.querySelectorAll('header-drawer summary').forEach(function (el) {
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function abrir() {
    var m = menu();
    if (!m) return false;
    var salva = null;
    try { salva = sessionStorage.getItem(CHAVE); } catch (e) {}
    if (salva) mostrarAba(m, salva, false);
    contarFavoritos(m);
    contarCarrinho(m);
    m.classList.add('is-aberto');
    requestAnimationFrame(function () { moverBarra(m, false); });
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rcm-travado');
    marcarX(true);
    return true;
  }

  function fechar() {
    var m = menu();
    if (!m || !m.classList.contains('is-aberto')) return;
    m.classList.remove('is-aberto');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('rcm-travado');
    marcarX(false);
  }

  window.rcMenu = { abrir: abrir, fechar: fechar };

  window.addEventListener('resize', function () {
    var m = menu();
    if (m && m.classList.contains('is-aberto')) posicionar(m);
  });

  /* o icone de menu do cabecalho (summary do header-drawer) abre o novo menu */
  document.addEventListener('click', function (e) {
    var gatilho = e.target.closest('header-drawer summary, .header__icon--menu');
    if (!gatilho || !menu()) return;
    e.preventDefault();
    e.stopPropagation();
    var det = gatilho.closest('details');
    if (det && det.hasAttribute('open')) det.removeAttribute('open');
    if (menu().classList.contains('is-aberto')) fechar();
    else abrir();
  }, true);

  document.addEventListener('click', function (e) {
    var m = menu();
    if (!m || !m.contains(e.target)) return;
    var t;
    if ((t = e.target.closest('[data-rcm-fechar]'))) {
      fechar();
    } else if ((t = e.target.closest('[data-rcm-aba]'))) {
      mostrarAba(m, t.getAttribute('data-rcm-aba'), true);
      var corpo = m.querySelector('[data-rcm-corpo]');
      if (corpo) corpo.scrollTop = 0;
    } else if ((t = e.target.closest('[data-rcm-abrir]'))) {
      abrirSub(m, t.getAttribute('data-rcm-abrir'));
    } else if ((t = e.target.closest('[data-rcm-voltar]'))) {
      fecharSub(m);
    } else if ((t = e.target.closest('[data-rcm-fav]'))) {
      fechar();
      if (window.rcFav && window.rcFav.abrirLista) window.rcFav.abrirLista();
    } else if ((t = e.target.closest('[data-rcm-cart]'))) {
      fechar();
      var gaveta = document.querySelector('cart-drawer');
      if (gaveta && typeof gaveta.open === 'function') gaveta.open();
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    } else if (e.target.closest('a[href]')) {
      fechar();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fechar();
  });

  /* editor do tema: abre o menu quando a secao ou um bloco e escolhido */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-rcm]')) abrir();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-rcm]')) fechar();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var m = menu();
    if (!m || !m.contains(e.target)) return;
    abrir();
    if (e.target.hasAttribute('data-rcm-aba')) mostrarAba(m, e.target.getAttribute('data-rcm-aba'), true);
  });
})();
